import React from "react";
import { createRoot } from 'react-dom/client';
import "./index.css";
import App from "./App";
import { HashRouter } from "react-router-dom";

// Footer'daki sosyal medya ikonları ve CTA güven satırı için Font Awesome 6 yüklenir.
// Public/index.html'e elle <link> eklenmesine gerek kalmaması için runtime'da enjekte edilir.
(function injectFontAwesome() {
  const FA_HREF = "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css";
  if (typeof document === "undefined") return;
  if (document.querySelector(`link[data-rabisu-fa]`)) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = FA_HREF;
  link.crossOrigin = "anonymous";
  link.referrerPolicy = "no-referrer";
  link.setAttribute("data-rabisu-fa", "true");
  document.head.appendChild(link);
})();

// Mirror tek tema (dark) çalışacağından <html> üzerine sabit data-theme bayrağı set edilir.
if (typeof document !== "undefined" && !document.documentElement.getAttribute("data-theme")) {
  document.documentElement.setAttribute("data-theme", "dark");
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <HashRouter>
    <App />
  </HashRouter>
);
